"use strict";

exports.__esModule = true;
exports.UtilizationChart = void 0;
var _react = _interopRequireDefault(require("react"));
var _ChartCard = require("../common/ChartCard");
var _reactIntl = require("react-intl");
var _UtilizationChartElement = require("./UtilizationChartElement");
var _UtilizationChartFields = require("./UtilizationChartFields");
var _UtilizationChartThumbnail = require("./UtilizationChartThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var UtilizationChart = exports.UtilizationChart = {
  name: "UtilizationChart",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "UtilizationChart.label",
    defaultMessage: "Utilization Chart"
  }),
  icon: "th-list",
  group: _widgetGroups.METRIC_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "UtilizationChart",
      props: Object.assign({
        width: 512,
        height: 512,
        aggregations: [],
        filters: [],
        hideXAxis: false,
        hideYAxis: false,
        hideYUnits: false,
        showLegends: true,
        tooltipSort: "desc"
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "onClickAction"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 3840
    },
    height: {
      "default": 64,
      min: 32,
      max: 2160
    }
  },
  components: {
    Element: (0, _ChartCard.withChartCard)(_UtilizationChartElement.UtilizationChartElement, function () {
      return {
        title: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "UtilizationChartWidget.card.title",
          defaultMessage: "Utilization"
        })
      };
    }),
    Fields: _UtilizationChartFields.UtilizationChartFields,
    Thumbnail: _UtilizationChartThumbnail.UtilizationChartThumbnail
  }
};